module.exports = __webpack_public_path__ + "img/notts-police-logo.8caadb69.jpg";